import { format, isValid, parseISO } from 'date-fns';

const DATE_ONLY_FORMAT = 'yyyy-MM-dd';
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const parseDateOnly = (value) => {
  if (typeof value !== 'string' || !DATE_ONLY_PATTERN.test(value)) return null;

  const date = parseISO(value);
  return isValid(date) && format(date, DATE_ONLY_FORMAT) === value ? date : null;
};

export const formatDateOnly = (date) =>
  date instanceof Date && isValid(date) ? format(date, DATE_ONLY_FORMAT) : null;
